module.exports = __webpack_public_path__ + "img/avatar-generic.13a41107.png";